import { useBoardFromContext } from "../../../utils/hooks/commonly-stored/uploaded-board/board";
import {
  BillableElement,
  BillOfMaterials,
  Board,
} from "../../../reducers/uploadedBoard";
import {
  AlertContainer,
  AlertText,
  GentleText,
} from "../ManufacturersPanelStyles";
import Icon from "../../common/Icon";
import React, { useEffect, useState } from "react";
import {
  BoardView,
  getBoardViewPath,
} from "../../../utils/models/boardToolSteps";
import { elementHasMissingPlacementInfo } from "../../../utils/placementChecks";
import { useBillOfMaterials } from "../../../utils/hooks/commonly-stored/uploaded-board/updates/billOfMaterials";

function getElementsWithoutPlacementInfo(
  billOfMaterials: BillOfMaterials | null,
): BillableElement[] {
  if (billOfMaterials === null) {
    return [];
  }
  return billOfMaterials.elements.filter((element) => {
    return elementHasMissingPlacementInfo(element);
  });
}

function useElementsWithoutPlacementInfo(): BillableElement[] {
  const billOfMaterials = useBillOfMaterials();
  const [elementsWithoutPlacementInfo, setElementsWithoutPlacementInfo] =
    useState(getElementsWithoutPlacementInfo(billOfMaterials));

  useEffect(() => {
    setElementsWithoutPlacementInfo(
      getElementsWithoutPlacementInfo(billOfMaterials),
    );
  }, [billOfMaterials]);

  return elementsWithoutPlacementInfo;
}

export function OneLineMissingPlacements() {
  const board = useBoardFromContext().board as Board;
  const elementsWithoutPlacementInfo = useElementsWithoutPlacementInfo();
  if (elementsWithoutPlacementInfo.length === 0) {
    return null;
  }

  return (
    <AlertText>
      This board has missing placement data. Click{" "}
      <a href={getBoardViewPath(board.id, BoardView.BOM)} target={"_blank"}>
        here
      </a>{" "}
      to correct.
    </AlertText>
  );
}

export default function MissingPlacements() {
  const elementsWithoutPlacementInfo = useElementsWithoutPlacementInfo();

  if (elementsWithoutPlacementInfo.length === 0) {
    return null;
  }

  return (
    <AlertContainer>
      <GentleText>Elements without placement info:</GentleText>
      {elementsWithoutPlacementInfo.map((element) => {
        return (
          <AlertText key={element.id}>
            <Icon src="/icons/alert_red.svg" alt="alert" />
            {element.name}
          </AlertText>
        );
      })}
    </AlertContainer>
  );
}
